export const FETCH_JOB_SETUP_QUALIFICATIONS_REQUEST = 'FETCH_JOB_SETUP_QUALIFICATIONS_REQUEST';
export const FETCH_JOB_SETUP_QUALIFICATIONS_SUCCESS = 'FETCH_JOB_SETUP_QUALIFICATIONS_SUCCESS';
export const FETCH_JOB_SETUP_QUALIFICATIONS_FAILURE = 'FETCH_JOB_SETUP_QUALIFICATIONS_FAILURE';

export const SAVE_JOB_SETUP_QUALIFICATION_REQUEST = 'SAVE_JOB_SETUP_QUALIFICATION_REQUEST';
export const SAVE_JOB_SETUP_QUALIFICATION_SUCCESS = 'SAVE_JOB_SETUP_QUALIFICATION_SUCCESS';
export const SAVE_JOB_SETUP_QUALIFICATION_FAILURE = 'SAVE_JOB_SETUP_QUALIFICATION_FAILURE';

export const CHANGE_JOB_SETUP_QUALIFICATION_STATUS_REQUEST = 'CHANGE_JOB_SETUP_QUALIFICATION_STATUS_REQUEST';
export const CHANGE_JOB_SETUP_QUALIFICATION_STATUS_SUCCESS = 'CHANGE_JOB_SETUP_QUALIFICATION_STATUS_SUCCESS';
export const CHANGE_JOB_SETUP_QUALIFICATION_STATUS_FAILURE = 'CHANGE_JOB_SETUP_QUALIFICATION_STATUS_FAILURE';
